var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E794016A-F2AE-4E4D-80F0-63429C3D3EA8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.7386,11.7 C40.7322,11.7 41.5386,12.5064 41.5386,13.5 L41.5386,17.1 C41.5386,18.0936 40.7322,18.9 39.7386,18.9 L1.8,18.9 C0.8046,18.9 -1.41669941e-13,18.0936 -1.41669941e-13,17.1 L-1.41669941e-13,13.5 C-1.41669941e-13,12.5064 0.8046,11.7 1.8,11.7 L39.7386,11.7 Z M52.2,0 C53.1936,0 54,0.8064 54,1.8 L54,5.4 C54,6.3936 53.1936,7.2 52.2,7.2 L1.8,7.2 C0.8046,7.2 -3.50885302e-14,6.3936 -3.50885302e-14,5.4 L-3.50885302e-14,1.8 C-3.50885302e-14,0.8064 0.8046,0 1.8,0 L52.2,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,21.6 C53.1936,21.6 54,22.4064 54,23.4 L54,27 C54,27.9936 53.1936,28.8 52.2,28.8 L1.8,28.8 C0.8046,28.8 5.18696197e-14,27.9936 5.18696197e-14,27 L5.18696197e-14,23.4 C5.18696197e-14,22.4064 0.8046,21.6 1.8,21.6 L52.2,21.6 Z M31.4298,10.8 C32.4252,10.8 33.2298,11.6064 33.2298,12.6 L33.2298,16.2 C33.2298,17.1936 32.4252,18 31.4298,18 L1.8,18 C0.8046,18 -5.1159077e-14,17.1936 -5.1159077e-14,16.2 L-5.1159077e-14,12.6 C-5.1159077e-14,11.6064 0.8046,10.8 1.8,10.8 L31.4298,10.8 Z M31.4298,0 C32.4252,0 33.2298,0.8064 33.2298,1.8 L33.2298,5.4 C33.2298,6.3936 32.4252,7.2 31.4298,7.2 L1.8,7.2 C0.8046,7.2 -5.1159077e-14,6.3936 -5.1159077e-14,5.4 L-5.1159077e-14,1.8 C-5.1159077e-14,0.8064 0.8046,0 1.8,0 L31.4298,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1219.000000, -710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-Copy-4",
    transform: "translate(1077.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Bar-Chart/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(9.000360, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000360, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(9.000360, 34.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000360, -34.200000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.809b573b6c283d3cdff2c04a39cea9f6.svg";
export { ForwardRef as ReactComponent };